{
  "bicycle": "Bicycle",
  "bicycle_required": "Bicycle choice is required",
  "body_height": "Height (cm)",
  "body_height_integer": "Body height should be a whole number of centimers",
  "body_height_positive": "Body height should be a positive number",
  "body_height_required": "Body height is required",
  "body_height_too_high": "Body height should be less than 300 centimeters",
  "body_height_too_low": "Body height should be at least 100 centimeters",
  "body_height_tooltip": "In order to arrange suitable bikes for you on board, we would like to know your height in cm.",
  "cabin": "Cabin",
  "cabin_full": "Cabin has too many occupants",
  "cabin_required": "Cabin assignment is required",
  "city": "City",
  "city_required": "City is required",
  "country": "Country",
  "country_required": "Country is required",
  "customer_remarks": "Customer Remarks",
  "date_day_placeholder": "DD",
  "date_month_placeholder": "MM",
  "date_of_birth": "Date of Birth (DD-MM-YYYY)",
  "date_of_birth_in_past": "Date of birth should be in the past",
  "date_of_birth_invalid": "Date of birth is not a valid date",
  "date_of_birth_required": "Date of birth is required",
  "date_of_birth_too_far_in_the_past": "Date of birth is too far in the past",
  "date_year_placeholder": "YYYY",
  "diet": "Special diet",
  "email_address": "Email Address",
  "email_address_email": "Email address has to be a valid email address",
  "email_address_optional": "Email Address (optional)",
  "email_address_required": "Email address is required",
  "email_address_undeliverable": "We could not verify this email address, please check it",
  "first_name": "First Name",
  "first_name_required": "First name is required",
  "gender": "Gender",
  "gender_choice": "Gender is required to be male or female",
  "group_name": "Group name",
  "last_name": "Last Name",
  "last_name_required": "Last name is required",
  "no_countries_found": "No countries found",
  "phone_number": "Phone number",
  "phone_number_invalid": "Enter a valid phone number",
  "phone_number_optional": "Phone number (optional)",
  "phone_number_required": "Phone number is required",
  "search_country": "Search country",
  "state": "State/Province",
  "state_invalid": "State/Province is invalid",
  "state_required": "State/Province is required",
  "street_address": "Street Address",
  "street_address_required": "Address is required",
  "zip_code": "Zip code",
  "zip_code_required": "Zip code is required"
}
